import * as React from "react";
import { Wind, Droplets, Snowflake, ThermometerSnowflake, Flame, CircleDashed, Box, Utensils, Wine, Trash2, ArrowRight, House, MapPin, BookOpen } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
const services = [{
  id: "meds-management",
  title: "ניהול תרופות ומעקב רפואי",
  description: "שירות מקצועי הכולל השגחה קפדנית על נטילת תרופות בזמן, מעקב אחר מדדים חיוניים ותיאום מול הצוות הרפואי. המטפלים שלנו מוודאים שכל מרשם מבוצע במדויק למניעת סיבוכים.",
  icon: Wind,
  link: "/CaregiverServicePagesPage",
  linkText: "קראו עוד על ניהול תרופות ומעקב"
}, {
  id: "post-hospital",
  title: "ליווי לאחר אשפוז",
  description: "סיוע בתהליך ההחלמה בבית לאחר שחרור מבית החולים. אנו מספקים תמיכה פיזית ורגשית, עזרה בניידות וביצוע הנחיות רפואיות כדי להבטיח חזרה מהירה ובטוחה לשגרה המוכרת.",
  icon: Droplets,
  link: "/CaregiverServicePagesPage",
  linkText: "למידע על ליווי לאחר אשפוז"
}, {
  id: "elderly-supervision",
  title: "השגחה צמודה לקשישים",
  description: "מתן מענה בטיחותי ומקצועי 24/7 בבית המטופל. השירות כולל סיוע בפעולות יומיומיות, מניעת נפילות ויצירת סביבה תומכת המאפשרת לקשיש להזדקן בכבוד ובביטחון מקסימלי.",
  icon: Snowflake,
  link: "/CaregiverServicePagesPage",
  linkText: "פרטים על השגחה צמודה לקשישים"
}, {
  id: "companionship",
  title: "ליווי וחברה למטופלים",
  description: "תמיכה רגשית וחברתית המפיגה את תחושת הבדידות. המטפלים שלנו משלבים שיחות, פעילויות פנאי וליווי לטיולים, תוך דגש על יצירת קשר אישי עמוק ושיפור איכות החיים הנפשית.",
  icon: ThermometerSnowflake,
  link: "/CaregiverServicePagesPage",
  linkText: "גלו עוד על שירותי ליווי וחברה"
}, {
  id: "home-caregiver",
  title: "מטפל סיעודי בבית",
  description: "שירותי סיעוד מותאמים אישית בבית הלקוח. אנו מספקים מטפלים מוסמכים המעניקים טיפול אישי, רחצה, האכלה וניהול משק הבית, תוך שמירה על פרטיות המטופל ונוחותו המלאה.",
  icon: Box,
  link: "/CaregiverServicePagesPage",
  linkText: "הזמינו מטפל סיעודי לביתכם"
}, {
  id: "hospital-watch",
  title: "השגחה בבית חולים",
  description: "ליווי צמוד במהלך שהות במוסד רפואי. הצוות שלנו נמצא לצד המטופל כאשר המשפחה אינה יכולה, מוודא קבלת מענה מהיר מהאחיות ומעניק תמיכה פיזית ורגשית ברגעים הקשים.",
  icon: CircleDashed,
  link: "/CaregiverServicePagesPage",
  linkText: "שירותי השגחה בבית חולים"
}, {
  id: "hygiene-assistance",
  title: "סיוע בהיגיינה וטיפוח",
  description: "שמירה על כבוד המטופל דרך סיוע ברחצה, הלבשה וטיפוח אישי. המטפלים שלנו פועלים ברגישות רבה ובמקצועיות כדי להבטיח תחושת רעננות וניקיון יומיומית בכל מצב תפקודי.",
  icon: Flame,
  link: "/CaregiverServicePagesPage",
  linkText: "למידע על סיוע בהיגיינה"
}, {
  id: "nutrition-support",
  title: "תזונה והכנת ארוחות",
  description: "תכנון והכנת ארוחות מזינות המותאמות למגבלות בריאותיות. אנו דואגים לתזונה מאוזנת, סיוע בהאכלה במידת הצורך ומעקב אחר שתייה מספקת למניעת התייבשות וחולשה.",
  icon: Box,
  link: "/CaregiverServicePagesPage",
  linkText: "קראו על תמיכה תזונתית"
}, {
  id: "mobility-help",
  title: "סיוע בניידות ופיזיותרפיה",
  description: "עזרה במעברים מהמיטה לכיסא, ליווי בהליכה ותרגול תרגילי פיזיותרפיה בסיסיים. המטרה היא לשמר את היכולת התנועתית של המטופל ולמנוע פצעי לחץ או ניוון שרירים.",
  icon: Utensils,
  link: "/CaregiverServicePagesPage",
  linkText: "למידע על סיוע בניידות"
}, {
  id: "dementia-care",
  title: "טיפול בחולי דמנציה",
  description: "גישה טיפולית ייחודית המותאמת לירידה קוגניטיבית. המטפלים שלנו מיומנים בהתמודדות עם בלבול, חוסר שקט ושינויי התנהגות, תוך יצירת סדר יום מרגיע ובטוח עבור המטופל.",
  icon: Wine,
  link: "/CaregiverServicePagesPage",
  linkText: "שירותי טיפול בחולי דמנציה"
}, {
  id: "night-care",
  title: "שירותי סיעוד לילה",
  description: "השגחה לילית למטופלים הזקוקים לסיוע בקימה לשירותים, שינויי תנוחה או הרגעה. השירות מאפשר לבני המשפחה לישון בשקט בידיעה שיש מי שדואג ליקירם לאורך כל שעות החשיכה.",
  icon: Flame,
  link: "/CaregiverServicePagesPage",
  linkText: "פרטים על שירותי סיעוד לילה"
}, {
  id: "family-guidance",
  title: "הדרכה וליווי למשפחות",
  description: "מתן כלים מקצועיים לבני המשפחה להתמודדות עם המצב הסיעודי. אנו מספקים ייעוץ לגבי זכויות, התאמת הבית למטופל ותמיכה רגשית לאורך כל הדרך המשותפת.",
  icon: Trash2,
  link: "/CaregiverServicePagesPage",
  linkText: "קבלו הדרכה וליווי למשפחה"
}, {
  id: "homepage-nav",
  title: "דף הבית - סיעוד מיידי",
  description: "חזרה לעמוד הראשי לקבלת סקירה מלאה על כל שירותי הסיעוד המיידיים שלנו בפריסה ארצית, כולל מטפלים ישראלים בלבד הזמינים תוך 5 שעות.",
  icon: House,
  link: "/HomePage",
  linkText: "חזרה לדף הבית של Siudy"
}, {
  id: "jerusalem-branch",
  title: "מטפל סיעודי בירושלים",
  description: "שירותי סיעוד מקצועיים בירושלים והסביבה. אנו מגיעים לכל שכונות העיר ומספקים מענה מהיר בבית או בבתי החולים המובילים בבירה.",
  icon: MapPin,
  link: "/NursingCareProviderInJerusalemWithinFiveHoursPage",
  linkText: "לשירותי סיעוד בירושלים"
}, {
  id: "haifa-branch",
  title: "מטפל סיעודי בחיפה",
  description: "זקוקים למטפל בחיפה? הצוות שלנו זמין עבורכם בחיפה והקריות למתן שירותי השגחה וסיעוד בסטנדרטים הגבוהים ביותר ובזמינות מיידית.",
  icon: MapPin,
  link: "/NursingCareProviderInHaifaWithinHoursPage",
  linkText: "לשירותי סיעוד בחיפה"
}, {
  id: "ramat-gan-branch",
  title: "מטפל סיעודי ברמת גן",
  description: "שירותי סיעוד ברמת גן, כולל השגחה בבתי חולים באזור המרכז. מטפלים ישראלים מנוסים המגיעים אליכם תוך פחות מ-5 שעות.",
  icon: MapPin,
  link: "/NursingCareInRamatGanWithinHoursPage",
  linkText: "לשירותי סיעוד ברמת גן"
}, {
  id: "professional-blog",
  title: "הבלוג המקצועי שלנו",
  description: "מאמרים, מדריכים ומידע חיוני על זכויות סיעוד, בחירת מטפל, והתמודדות עם מצבים רפואיים שונים. כל מה שצריך לדעת במקום אחד.",
  icon: BookOpen,
  link: "/ProfessionalBlogPage",
  linkText: "קראו בבלוג המקצועי"
}];
export default function ServiceGrid() {
  return <section data-section-id="257288" id="שירותים-סיעודיים-בתל-אביב" className="bg-background py-16 md:py-24 text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 max-w-3xl">
          <span className="mb-2 block text-sm font-bold tracking-wider text-primary uppercase">
            השירותים והניווט שלנו
          </span>
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl">
            מעטפת סיעודית ומידע מקצועי
            <span className="block font-light text-muted-foreground mt-2 text-2xl sm:text-3xl md:text-4xl">
              כל הפתרונות במקום אחד: שירותים, ערים ומאמרים
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className="group relative flex flex-col overflow-hidden border-border/50 bg-card transition-all duration-300 hover:border-primary hover:shadow-lg rounded-lg">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-accent text-primary transition-colors group-hover:bg-accent/20">
                    <Icon className="h-6 w-6 stroke-[1.5]" />
                  </div>
                  <CardTitle className="font-default text-xl font-semibold text-foreground transition-colors group-hover:text-primary">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow pb-6 pt-0">
                  <p className="text-sm text-muted-foreground font-default leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
                <CardFooter className="pt-0 mt-auto">
                  <Link to={service.link} className="inline-flex items-center gap-1 text-sm font-medium text-primary transition-colors hover:text-primary/80 hover:underline">
                    {service.linkText} <ArrowRight className="h-4 w-4 transition-transform group-hover:-translate-x-1 rotate-180" />
                  </Link>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}